module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-sound_off@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/btn-sound_off@2x.png
// module id = 603
// module chunks = 0